<div
  class="accordion-card"
  [class.selected]="isOpen() && !isAlwaysOpen()"
  [class.always-open]="isAlwaysOpen()"
  [class.collapsable]="isCollapsable()"
  [class.no-border]="hideBorder()"
  [class.readonly]="isReadonly()"
  [attr.tabindex]="isCollapsable() ? 0 : undefined"
  [attr.role]="isCollapsable() ? 'button' : undefined"
  [attr.aria-expanded]="isCollapsable() ? isOpen() : undefined"
  (click)="onContainerClick($event)"
  (keydown.enter)="onContainerKeydown($event)"
  (keydown.space)="onContainerKeydown($event)"
  [id]="id()"
  #accordionCardContainer
>
  <div class="accordion-card-header">
    <div
      class="accordion-card-title"
      [class.accordion-card-title-break-word]="breakWordForTitle()"
    >
      @if (titleTemplate()) {
        <ng-container *ngTemplateOutlet="titleTemplate()" />
      } @else {
        {{ title() }}
      }
    </div>
    <lib-icon name="chevron-down" class="accordion-card-icon" />
  </div>
  @if (subtitle()) {
    <div class="accordion-card-subtitle" [innerHTML]="subtitle()"></div>
  }
  <div
    class="accordion-card-content"
    [class.open]="isOpen()"
    [class.collapsed]="!isOpen()"
    [attr.inert]="!isOpen() ? '' : null"
    [attr.aria-hidden]="!isOpen() ? 'true' : null"
  >
    <div class="accordion-card-body">
      @if (isStorybookPreview()) {
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Delectus
          officia molestiae obcaecati vitae, voluptas ullam nobis nostrum saepe
          deserunt perspiciatis sed praesentium, est, at minima iure debitis
          facere nemo illum.
        </p>
      }
      <ng-content></ng-content>
    </div>
  </div>
</div>
